export const DEBUG_MODE = !! process.env.VUE_APP_DEBUG_MODE
export const PRODUCTION_MODE = false;

